var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pager404 full-height full-width text-center"},[_c('q-img',{attrs:{"src":require("assets/images/error/error404.png"),"ratio":16 / 10}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-size-24 q-mt-xl text-weight-bold text-black"},[_c('div',[_vm._v("Sorry,")]),_c('div',[_vm._v("the page no longer exists")])])
}]

export { render, staticRenderFns }